import { GeneralCatalogItem } from 'data-layer-cr/dist/models';

export default function catalogItemForCode(
  code: string,
  items: GeneralCatalogItem[],
): GeneralCatalogItem {
  const foundItem = items.find((catalogItem) => catalogItem.code === code);
  if (foundItem) {
    return foundItem;
  }
  return { id: 0, code: '', name: '' };
}
